var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeweW3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f5f453bd-05fc-4bad-8c72-3f6fdbacc984",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 459 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.502,32.6488h-12.3819V5.4086h28.6556v29.0091l-14.8584,27.2402h-15.9202l14.5049-29.0091ZM436.0017,32.6488h-12.3819V5.4086h28.6556v29.0091l-14.8584,27.2402h-15.9202l14.5049-29.0091Z",
    fill: "#fff",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.3551,37.7486h22.6406l5.3066,65.7988,9.1982-65.7988h24.9395l9.375,65.6221,5.3066-65.6221h22.6406l-10.79,95.1611h-29.1855l-9.7275-72.167-9.9053,72.167H11.1451L.3551,37.7486Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.607,92.5806v-15.7422c0-27.416,12.5586-42.0967,38.9131-42.0967,28.6543,0,38.0293,15.3877,38.0293,47.7568v5.1299h-50.0566v1.415c0,18.2188,1.415,28.4775,11.8506,28.4775,6.7217,0,11.6738-2.6533,11.6738-16.0957v-.708h25.2939v.8848c0,25.8242-19.1025,33.4297-37.498,33.4297-26.5322,0-38.2061-15.3877-38.2061-42.4512ZM135.4928,73.1245h25.1162v-1.5918c0-13.9736-2.8301-19.8105-12.5586-19.8105-9.5508,0-12.5576,5.8369-12.5576,19.8105v1.5918Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1598,37.7486h22.6406l5.3057,65.7988,9.1982-65.7988h24.9395l9.375,65.6221,5.3066-65.6221h22.6406l-10.79,95.1611h-29.1846l-9.7285-72.167-9.9053,72.167h-29.0088l-10.7891-95.1611Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.4107,92.5806v-15.7422c0-27.416,12.5576-42.0967,38.9131-42.0967,28.6543,0,38.0293,15.3877,38.0293,47.7568v5.1299h-50.0566v1.415c0,18.2188,1.415,28.4775,11.8506,28.4775,6.7217,0,11.6738-2.6533,11.6738-16.0957v-.708h25.2939v.8848c0,25.8242-19.1025,33.4297-37.498,33.4297-26.5322,0-38.2061-15.3877-38.2061-42.4512ZM328.2965,73.1245h25.1162v-1.5918c0-13.9736-2.8301-19.8105-12.5576-19.8105-9.5518,0-12.5586,5.8369-12.5586,19.8105v1.5918Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeweW3);
export default __webpack_public_path__ + "static/media/wewe_w_3.ef854eac9e0e200267aff14a4ee3c0b0.svg";
export { ForwardRef as ReactComponent };